import { render, staticRenderFns } from "./MoldBOM.vue?vue&type=template&id=5228d532&"
import script from "./MoldBOM.vue?vue&type=script&lang=js&"
export * from "./MoldBOM.vue?vue&type=script&lang=js&"
import style0 from "./MoldBOM.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports